import React, { useContext, useEffect, useMemo, useState } from "react";
import { Box, IconButton } from "@mui/material";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DataTable from "../../components/common/DataTable";
import CustomModal from "../../components/common/CustomModal";
import { genericPost } from '../../services/authServices';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CustomLoader from "../../components/common/CustomLoader";
import MessageBox from "../../components/common/CustomMessageBox";
import { AuthContext } from "../../context/AuthContext";
import CustomDelete from '../../components/common/CustomDeleteAlert'
import CustomMaster from '../../components/common/CustomMaster'
import axios from "axios";
import CreateCaseStudy from "../components/CreateForm/CreateCaseStudy";
import UpdateCaseStudy from "../components/UpdateForm/UpdateCaseStudy";
import { CASE_STUDY_GET, CASE_STUDY_DELETE } from "../../services/apiRoutes";
import { getBlogCategoryList, getBlogStatusList } from "../../services/CommonServices";

const title = "Case Studies";

const CaseStudies = () => {
    const { token } = useContext(AuthContext)

    const [modal, setModal] = useState(false);
    const [caseStudies, setCaseStudies] = useState([]); // ✅ changed
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const [updateModal, setUpdateModal] = useState(false);
    const [blogCategory, setBlogCategory] = useState([]);
    const [blogStatus, setBlogStatus] = useState([]);
    const [selectedId, setSelectedId] = useState(null);

    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    })

    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')

    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }

    const handleCloseUpdate = () => {
        setUpdateModal(false);
    };

    const handleUpdateClick = (caseStudyId) => { // ✅ changed
        setSelectedId(caseStudyId);
        setUpdateModal(true);
    };

    const columns = useMemo(() => [
        { accessorKey: "index", header: "SN.", size: 50, enableColumnFilter: false },
        { accessorKey: "title", header: "Title", size: 200 },
        { accessorKey: "category", header: "Category", size: 100 },
        { accessorKey: "authorName", header: "Author", size: 150 },
        { accessorKey: "views", header: "Views", size: 80 },
        {
            accessorKey: "status",
            header: "Status",
            size: 100,
            Cell: ({ cell }) => (
                <span style={{
                    color: cell.getValue() === "Published" ? "green" : "orange",
                    fontWeight: "bold",
                }}>
                    {cell.getValue()}
                </span>
            ),
        },
        {
            accessorKey: "publishedAt",
            header: "Published Date",
            size: 150,
            Cell: ({ cell }) => cell.getValue() ? new Date(cell.getValue()).toLocaleDateString() : "",
        },
        {
            accessorKey: "createdAt",
            header: "Created At",
            size: 150,
            Cell: ({ cell }) => cell.getValue() ? new Date(cell.getValue()).toLocaleDateString() : "",
        },
        {
            accessorKey: "action",
            header: "Action",
            size: 100,
            Cell: ({ row }) => (
                <div style={{ display: "flex", justifyContent: "center", gap: "4px" }}>
                    <IconButton onClick={() => handleUpdateClick(row.original.caseStudyId)}>
                        <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                    </IconButton>

                    <IconButton onClick={() => handleOpenDeleteAlert(row.original.caseStudyId)}>
                        <DeleteOutlineOutlinedIcon style={{ color: "#E4003A" }} />
                    </IconButton>
                </div>
            ),
        },
    ], []);

    const getCaseStudyList = async () => { // ✅ changed
        setLoading(true);
        try {
            const response = await genericPost(CASE_STUDY_GET, {});

            if (response.data.success && response.data.caseStudies) {
                const caseStudyData = response.data.caseStudies.map((caseStudy, index) => ({
                    caseStudyId: caseStudy.caseStudyId || '',
                    index: (index + 1).toString().padStart(2, '0'),

                    userId: caseStudy.userId || '',
                    companyId: caseStudy.companyId || '',

                    title: caseStudy.title || '',
                    content: caseStudy.content || '',
                    featuredImage: caseStudy.featuredImage || '',
                    category: caseStudy.categoryList?.categoryName || '',
                    status: caseStudy.statusList?.statusName || '',

                    metaTitle: caseStudy.metaTitle || '',
                    metaDescription: caseStudy.metaDescription || '',

                    views: caseStudy.views || 0,
                    publishedAt: caseStudy.publishedAt || '',
                    createdAt: caseStudy.createdAt || '',
                    updatedAt: caseStudy.updatedAt || '',

                    authorName: caseStudy.user
                        ? `${caseStudy.user.firstName || ''} ${caseStudy.user.lastName || ''}`
                        : '',
                }));

                setCaseStudies(caseStudyData); // ✅ changed
            } else {
                setError('No case studies found');
            }
        } catch (error) {
            setError('Error fetching case studies');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (caseStudyId) => { // ✅ changed
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(CASE_STUDY_DELETE(caseStudyId), {
                headers: { Authorization: `Bearer ${authToken}` },
            });

            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: "Case Study deleted successfully", // ✅ changed
                    type: "success",
                });

                getCaseStudyList(); // ✅ changed
                setDeleteAlert(false);
            }
        } catch (error) {
            setMessage({
                open: true,
                text: "Error deleting case study", // ✅ changed
                type: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getCaseStudyList(); // ✅ changed
    }, [token]);

    const handleOpen = () => setModal(true);
    const handleClose = () => setModal(false);

    useEffect(() => {
        getCommonData()
    }, [])

    const getCommonData = async () => {
        setBlogCategory(await getBlogCategoryList());
        setBlogStatus(await getBlogStatusList());
    }

    const defaultView = 'casestudies';

    return (
        <CustomMaster
            defaultView={defaultView}
            mainContent={
                <>
                    <Box sx={{ padding: "10px" }}>
                        <CustomLoader open={loading} />

                        <DataTable
                            title={title}
                            columns={columns}
                            data={caseStudies} // ✅ changed
                            handleOpen={handleOpen}
                            buttonTitle="Add Case Study" // ✅ changed
                        />

                        <CustomModal open={modal} handleClose={handleClose}>
                            <CreateCaseStudy
                                handleClose={handleClose}
                                fetchData={getCaseStudyList}
                                setMessage={setMessage}
                                blogCategory={blogCategory}
                                blogStatus={blogStatus}
                            />
                        </CustomModal>

                        <CustomModal open={updateModal} handleClose={handleCloseUpdate}>
                            <UpdateCaseStudy
                                handleClose={handleCloseUpdate}
                                caseStudyId={selectedId} // ✅ changed
                                getCaseStudyList={getCaseStudyList}
                                setMessage={setMessage}
                                blogCategory={blogCategory}
                                blogStatus={blogStatus}
                            />
                        </CustomModal>

                        <MessageBox
                            open={message.open}
                            message={message.text}
                            type={message.type}
                            handleClose={() => setMessage({ ...message, open: false })}
                        />
                    </Box>

                    <CustomDelete
                        handleDelete={handleDelete}
                        open={deleteAlert}
                        rowId={rowId}
                        handleClose={() => setDeleteAlert(false)}
                    />
                </>
            }
        />
    );
};

export default CaseStudies;